// extracted by mini-css-extract-plugin
export var aboutMessage = "Form-module--aboutMessage--3321c";
export var centerContainer = "Form-module--centerContainer--b7855";
export var field = "Form-module--field--224a7";
export var fieldInputLabel = "Form-module--fieldInputLabel--f7f99";
export var fieldSelectLabel = "Form-module--fieldSelectLabel--36db5";
export var formInput = "Form-module--formInput--0b761";
export var formSelect = "Form-module--formSelect--82742";
export var formWrapper = "Form-module--formWrapper--f0f3f";
export var invalid = "Form-module--invalid--200ba";
export var isInvalid = "Form-module--is-invalid--7485a";
export var leftSideContainer = "Form-module--leftSideContainer--c3f24";
export var rightSideContainer = "Form-module--rightSideContainer--68f1a";
export var subTitle = "Form-module--subTitle--ab481";
export var title = "Form-module--title--be32e";